import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {createStore, applyMiddleware} from "redux";
import thunk from "redux-thunk";
import logger from 'redux-logger';
import reduxPromise from 'redux-promise-middleware'

import rootReducer from './reducers/rootReducer';
import {composeWithDevTools} from "redux-devtools-extension";
import {Provider} from "react-redux";
import {BrowserRouter} from "react-router-dom";

import { MemoryRouter } from 'react-router'

import {APP_BASE} from "./config/env";

const store = createStore(
    rootReducer,
    composeWithDevTools(
        applyMiddleware(reduxPromise, thunk, logger)
    )
);

ReactDOM.render(
    <MemoryRouter basename={APP_BASE} >
        <Provider store={store}>
            <App/>
        </Provider>
    </MemoryRouter>,
    document.getElementById('root')
);

reportWebVitals();
